var _path, _g, _g2, _g3, _g4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServiceIcon04(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_743_3172)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.5842 46.0749C56.1104 44.9175 43.6036 40.5665 41.1653 34.2221V4.74992C41.1653 3.91007 40.8316 3.10461 40.2378 2.51075C39.6439 1.91688 38.8385 1.58325 37.9986 1.58325C37.1588 1.58325 36.3533 1.91688 35.7594 2.51075C35.1656 3.10461 34.8319 3.91007 34.8319 4.74992V34.2268C32.4047 40.5333 19.8869 44.9112 16.413 46.0749C16.018 46.2065 15.6527 46.4147 15.3381 46.6875C15.0235 46.9602 14.7657 47.2923 14.5794 47.6647C14.3931 48.0372 14.282 48.4426 14.2524 48.858C14.2228 49.2733 14.2753 49.6904 14.4069 50.0855C14.5386 50.4806 14.7467 50.8458 15.0195 51.1604C15.2923 51.4751 15.6243 51.7329 15.9968 51.9192C16.3692 52.1054 16.7746 52.2165 17.19 52.2461C17.6054 52.2757 18.0225 52.2232 18.4175 52.0916C18.9416 51.9174 32.3002 48.4499 37.9986 41.2616C43.6986 48.4468 57.0556 51.9174 57.5797 52.0916C57.9034 52.1987 58.2425 52.2522 58.5835 52.2499C59.3378 52.2531 60.0684 51.9871 60.6439 51.4995C61.2194 51.012 61.602 50.3351 61.7228 49.5906C61.8437 48.8461 61.6948 48.0829 61.303 47.4384C60.9113 46.7939 60.3007 46.3104 59.5842 46.0749Z",
    fill: "url(#paint0_linear_743_3172)"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: -8.83325,
    y: -0.91626,
    width: 52.5,
    height: 87.333
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(6px)",
      clipPath: "url(#bgblur_1_743_3172_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_743_3172)",
    "data-figma-bg-blur-radius": 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0597 74.4166C8.96493 74.4078 6.95884 73.5702 5.47985 72.0868C4.00086 70.6033 3.16924 68.5947 3.16675 66.5V47.5C3.16675 18.1038 29.4342 11.1957 29.7002 11.1308C29.9336 11.0726 30.1772 11.0683 30.4124 11.1183C30.6477 11.1683 30.8684 11.2712 31.058 11.4192C31.2475 11.5673 31.4009 11.7565 31.5063 11.9727C31.6118 12.1888 31.6667 12.4261 31.6667 12.6666V55.7127C31.6546 59.4948 30.4169 63.171 28.1393 66.1903C25.8616 69.2096 22.6666 71.4093 19.0333 72.4596L13.2589 74.1095C12.5436 74.3133 11.8034 74.4167 11.0597 74.4166Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0597 74.4166C8.96493 74.4078 6.95884 73.5702 5.47985 72.0868C4.00086 70.6033 3.16924 68.5947 3.16675 66.5V47.5C3.16675 18.1038 29.4342 11.1957 29.7002 11.1308C29.9336 11.0726 30.1772 11.0683 30.4124 11.1183C30.6477 11.1683 30.8684 11.2712 31.058 11.4192C31.2475 11.5673 31.4009 11.7565 31.5063 11.9727C31.6118 12.1888 31.6667 12.4261 31.6667 12.6666V55.7127C31.6546 59.4948 30.4169 63.171 28.1393 66.1903C25.8616 69.2096 22.6666 71.4093 19.0333 72.4596L13.2589 74.1095C12.5436 74.3133 11.8034 74.4167 11.0597 74.4166Z",
    fill: "url(#paint1_linear_743_3172)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.821 11.616C29.9806 11.5762 30.1474 11.573 30.3083 11.6072C30.4692 11.6413 30.6201 11.7121 30.7498 11.8132C30.8794 11.9145 30.9852 12.0443 31.0574 12.1921C31.1294 12.3399 31.1667 12.5023 31.1667 12.6667V55.7126C31.1546 59.386 29.9523 62.9568 27.74 65.8894C25.5274 68.8223 22.4236 70.9589 18.8943 71.9792L13.1218 73.6287C12.4513 73.8197 11.7575 73.9157 11.0603 73.9158C9.09828 73.9072 7.21908 73.1236 5.83374 71.7341C4.44814 70.3444 3.66918 68.4622 3.66675 66.4998V47.4998C3.66681 32.9759 10.1468 24.0341 16.6511 18.7029C19.9089 16.0328 23.1766 14.2664 25.6462 13.1638C26.8803 12.6129 27.9135 12.2284 28.6443 11.9802C29.0097 11.8562 29.2997 11.7664 29.5007 11.7068C29.6012 11.677 29.6797 11.6544 29.7341 11.6394C29.761 11.632 29.7818 11.6258 29.7966 11.6218C29.8117 11.6178 29.8191 11.617 29.8191 11.6169L29.821 11.616Z",
    stroke: "url(#paint2_linear_743_3172)",
    strokeOpacity: 0.1
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 32.3335,
    y: -0.91626,
    width: 52.5,
    height: 87.333
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(6px)",
      clipPath: "url(#bgblur_2_743_3172_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_743_3172)",
    "data-figma-bg-blur-radius": 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.9406 74.4166C67.0353 74.4078 69.0414 73.5702 70.5204 72.0868C71.9994 70.6033 72.831 68.5947 72.8335 66.5V47.5C72.8335 18.1038 46.566 11.1957 46.3 11.1308C46.0666 11.0726 45.8231 11.0683 45.5878 11.1183C45.3526 11.1683 45.1318 11.2712 44.9423 11.4192C44.7527 11.5673 44.5994 11.7565 44.4939 11.9727C44.3884 12.1888 44.3336 12.4261 44.3335 12.6666V55.7127C44.3456 59.4948 45.5833 63.171 47.861 66.1903C50.1387 69.2096 53.3336 71.4093 56.9669 72.4596L62.7413 74.1095C63.4566 74.3133 64.1968 74.4167 64.9406 74.4166Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9406 74.4166C67.0353 74.4078 69.0414 73.5702 70.5204 72.0868C71.9994 70.6033 72.831 68.5947 72.8335 66.5V47.5C72.8335 18.1038 46.566 11.1957 46.3 11.1308C46.0666 11.0726 45.8231 11.0683 45.5878 11.1183C45.3526 11.1683 45.1318 11.2712 44.9423 11.4192C44.7527 11.5673 44.5994 11.7565 44.4939 11.9727C44.3884 12.1888 44.3336 12.4261 44.3335 12.6666V55.7127C44.3456 59.4948 45.5833 63.171 47.861 66.1903C50.1387 69.2096 53.3336 71.4093 56.9669 72.4596L62.7413 74.1095C63.4566 74.3133 64.1968 74.4167 64.9406 74.4166Z",
    fill: "url(#paint3_linear_743_3172)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6919 11.6072C45.8528 11.573 46.0196 11.5762 46.1792 11.616L46.1812 11.6169C46.1812 11.617 46.1885 11.6178 46.2036 11.6218C46.2184 11.6258 46.2392 11.632 46.2661 11.6394C46.3206 11.6544 46.3991 11.677 46.4995 11.7068C46.7005 11.7664 46.9906 11.8562 47.356 11.9802C48.0868 12.2284 49.1199 12.6129 50.354 13.1638C52.8237 14.2664 56.0914 16.0328 59.3491 18.7029C65.8535 24.0341 72.3334 32.9759 72.3335 47.4998V66.4998L72.3237 66.866C72.2312 68.6951 71.4657 70.4311 70.1665 71.7341C68.7809 73.1238 66.9013 73.9074 64.939 73.9158C64.3294 73.9157 63.7224 73.8424 63.1313 73.696L62.8784 73.6287L57.105 71.9792H57.106C53.5766 70.9589 50.4728 68.8223 48.2603 65.8894C46.1859 63.1396 44.9999 59.8286 44.8501 56.3982L44.8335 55.7107V12.6667L44.8403 12.5437C44.8543 12.4219 44.8889 12.3029 44.9429 12.1921C45.015 12.0443 45.1208 11.9145 45.2505 11.8132C45.3801 11.7121 45.5311 11.6413 45.6919 11.6072Z",
    stroke: "url(#paint4_linear_743_3172)",
    strokeOpacity: 0.1
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 38.6667,
    y: -2.5,
    width: 49.3333,
    height: 49.3333
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(6px)",
      clipPath: "url(#bgblur_3_743_3172_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_743_3172)",
    "data-figma-bg-blur-radius": 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.3334 34.8333C70.329 34.8333 76.0001 29.1623 76.0001 22.1667C76.0001 15.1711 70.329 9.5 63.3334 9.5C56.3378 9.5 50.6667 15.1711 50.6667 22.1667C50.6667 29.1623 56.3378 34.8333 63.3334 34.8333Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3334 34.8333C70.329 34.8333 76.0001 29.1623 76.0001 22.1667C76.0001 15.1711 70.329 9.5 63.3334 9.5C56.3378 9.5 50.6667 15.1711 50.6667 22.1667C50.6667 29.1623 56.3378 34.8333 63.3334 34.8333Z",
    fill: "url(#paint5_linear_743_3172)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3337 10C70.0531 10.0002 75.4998 15.4476 75.4998 22.167C75.4996 28.8862 70.0529 34.3328 63.3337 34.333C56.6144 34.333 51.1669 28.8863 51.1667 22.167C51.1667 15.4475 56.6143 10 63.3337 10Z",
    stroke: "url(#paint6_linear_743_3172)",
    strokeOpacity: 0.1
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_743_3172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.2502 20.5832H69.4436C69.2952 20.0162 69.0688 19.4727 68.7707 18.9682L70.05 17.6888C70.3384 17.3902 70.498 16.9903 70.4944 16.5751C70.4908 16.16 70.3243 15.7629 70.0307 15.4693C69.7371 15.1757 69.34 15.0092 68.9249 15.0056C68.5097 15.002 68.1098 15.1616 67.8112 15.45L66.5318 16.7293C66.0273 16.4312 65.4838 16.2048 64.9168 16.0564V14.2498C64.9168 13.8299 64.75 13.4272 64.4531 13.1303C64.1562 12.8333 63.7534 12.6665 63.3335 12.6665C62.9136 12.6665 62.5108 12.8333 62.2139 13.1303C61.917 13.4272 61.7502 13.8299 61.7502 14.2498V16.0564C61.1832 16.2048 60.6397 16.4312 60.1352 16.7293L58.8558 15.45C58.5572 15.1616 58.1573 15.002 57.7421 15.0056C57.327 15.0092 56.9298 15.1757 56.6363 15.4693C56.3427 15.7629 56.1762 16.16 56.1726 16.5751C56.169 16.9903 56.3286 17.3902 56.617 17.6888L57.8963 18.9682C57.5982 19.4727 57.3717 20.0162 57.2234 20.5832H55.4168C54.9969 20.5832 54.5942 20.75 54.2972 21.0469C54.0003 21.3439 53.8335 21.7466 53.8335 22.1665C53.8335 22.5864 54.0003 22.9892 54.2972 23.2861C54.5942 23.583 54.9969 23.7498 55.4168 23.7498H57.2234C57.3717 24.3168 57.5982 24.8603 57.8963 25.3648L56.617 26.6442C56.4658 26.7902 56.3451 26.9649 56.2622 27.1581C56.1792 27.3513 56.1355 27.5591 56.1337 27.7693C56.1319 27.9795 56.1719 28.188 56.2515 28.3826C56.3311 28.5772 56.4487 28.754 56.5974 28.9026C56.746 29.0513 56.9228 29.1689 57.1174 29.2485C57.312 29.3281 57.5205 29.3681 57.7307 29.3663C57.941 29.3645 58.1487 29.3208 58.3419 29.2378C58.5351 29.1549 58.7098 29.0342 58.8558 28.883L60.1352 27.6037C60.6397 27.9018 61.1832 28.1283 61.7502 28.2766V30.0832C61.7502 30.5031 61.917 30.9058 62.2139 31.2028C62.5108 31.4997 62.9136 31.6665 63.3335 31.6665C63.7534 31.6665 64.1562 31.4997 64.4531 31.2028C64.75 30.9058 64.9168 30.5031 64.9168 30.0832V28.2766C65.4838 28.1283 66.0273 27.9018 66.5318 27.6037L67.8112 28.883C68.1098 29.1714 68.5097 29.331 68.9249 29.3274C69.34 29.3238 69.7371 29.1573 70.0307 28.8637C70.3243 28.5702 70.4908 28.173 70.4944 27.7579C70.498 27.3427 70.3384 26.9428 70.05 26.6442L68.7707 25.3648C69.0688 24.8603 69.2952 24.3168 69.4436 23.7498H71.2502C71.6701 23.7498 72.0728 23.583 72.3698 23.2861C72.6667 22.9892 72.8335 22.5864 72.8335 22.1665C72.8335 21.7466 72.6667 21.3439 72.3698 21.0469C72.0728 20.75 71.6701 20.5832 71.2502 20.5832Z",
    fill: "url(#paint7_linear_743_3172)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_743_3172",
    x: -8.83325,
    y: -0.91626,
    width: 52.5,
    height: 87.333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_743_3172"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_743_3172_clip_path",
    transform: "translate(8.83325 0.91626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0597 74.4166C8.96493 74.4078 6.95884 73.5702 5.47985 72.0868C4.00086 70.6033 3.16924 68.5947 3.16675 66.5V47.5C3.16675 18.1038 29.4342 11.1957 29.7002 11.1308C29.9336 11.0726 30.1772 11.0683 30.4124 11.1183C30.6477 11.1683 30.8684 11.2712 31.058 11.4192C31.2475 11.5673 31.4009 11.7565 31.5063 11.9727C31.6118 12.1888 31.6667 12.4261 31.6667 12.6666V55.7127C31.6546 59.4948 30.4169 63.171 28.1393 66.1903C25.8616 69.2096 22.6666 71.4093 19.0333 72.4596L13.2589 74.1095C12.5436 74.3133 11.8034 74.4167 11.0597 74.4166Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_743_3172",
    x: 32.3335,
    y: -0.91626,
    width: 52.5,
    height: 87.333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_743_3172"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_2_743_3172_clip_path",
    transform: "translate(-32.3335 0.91626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.9406 74.4166C67.0353 74.4078 69.0414 73.5702 70.5204 72.0868C71.9994 70.6033 72.831 68.5947 72.8335 66.5V47.5C72.8335 18.1038 46.566 11.1957 46.3 11.1308C46.0666 11.0726 45.8231 11.0683 45.5878 11.1183C45.3526 11.1683 45.1318 11.2712 44.9423 11.4192C44.7527 11.5673 44.5994 11.7565 44.4939 11.9727C44.3884 12.1888 44.3336 12.4261 44.3335 12.6666V55.7127C44.3456 59.4948 45.5833 63.171 47.861 66.1903C50.1387 69.2096 53.3336 71.4093 56.9669 72.4596L62.7413 74.1095C63.4566 74.3133 64.1968 74.4167 64.9406 74.4166Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_743_3172",
    x: 38.6667,
    y: -2.5,
    width: 49.3333,
    height: 49.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_743_3172"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_3_743_3172_clip_path",
    transform: "translate(-38.6667 2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.3334 34.8333C70.329 34.8333 76.0001 29.1623 76.0001 22.1667C76.0001 15.1711 70.329 9.5 63.3334 9.5C56.3378 9.5 50.6667 15.1711 50.6667 22.1667C50.6667 29.1623 56.3378 34.8333 63.3334 34.8333Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_743_3172",
    x: 53.8335,
    y: 12.6665,
    width: 19,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_743_3172"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_743_3172",
    x1: 38,
    y1: 3,
    x2: 60.7959,
    y2: 29.9436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCFF33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C32FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_743_3172",
    x1: 3.16675,
    y1: 11.0837,
    x2: 38.4428,
    y2: 15.1145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1FFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF31CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_743_3172",
    x1: 4.05737,
    y1: 13.9625,
    x2: 31.6667,
    y2: 13.9625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5EFFD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF40D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_743_3172",
    x1: 44.3335,
    y1: 11.0837,
    x2: 79.6096,
    y2: 15.1145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1FFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF31CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_743_3172",
    x1: 45.2241,
    y1: 13.9625,
    x2: 72.8335,
    y2: 13.9625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5EFFD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF40D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_743_3172",
    x1: 50.6667,
    y1: 9.5,
    x2: 80.5086,
    y2: 17.0774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1FFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF31CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_743_3172",
    x1: 51.4584,
    y1: 10.6515,
    x2: 76.0001,
    y2: 10.6515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5EFFD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF40D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_743_3172",
    x1: 63.5,
    y1: 29,
    x2: 63.5,
    y2: 13.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C32FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCFF33"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_743_3172"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIcon04);
export default __webpack_public_path__ + "static/media/service-icon04.216bd91a46eec2d60811a1bc614be1cc.svg";
export { ForwardRef as ReactComponent };